import { render, staticRenderFns } from "./DetailSwiper.vue?vue&type=template&id=49bd12cb&scoped=true&"
import script from "./DetailSwiper.vue?vue&type=script&lang=js&"
export * from "./DetailSwiper.vue?vue&type=script&lang=js&"
import style0 from "./DetailSwiper.vue?vue&type=style&index=0&id=49bd12cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd12cb",
  null
  
)

export default component.exports